import { Injectable } from '@angular/core';

@Injectable()
export class ResetService {
  initialState: any;
}
